import * as React from 'react';
import { SelectTrigger } from './select';
import { cn } from '@/lib/utils';

/**
 * SeveritySelectTrigger provides a uniform trigger component for severity selectors.
 * It ensures consistent styling, sizing, and minimum width across all severity
 * selection components in the application.
 *
 * Features:
 * - Consistent minimum width (min-w-48) for visual alignment across sections
 * - Auto width that expands to fit content
 * - Same styling applied uniformly
 */
export const SeveritySelectTrigger = React.forwardRef<
  React.ComponentRef<typeof SelectTrigger>,
  React.ComponentPropsWithoutRef<typeof SelectTrigger>
>(({ className, ...props }, ref) => {
  return (
    <SelectTrigger
      ref={ref}
      className={cn('min-w-48 w-auto', className)}
      {...props}
    />
  );
});

SeveritySelectTrigger.displayName = 'SeveritySelectTrigger';
